module.exports = __webpack_public_path__ + "img/DE02184.820587e9.png";